export default __webpack_public_path__ + "static/media/archi_card5.5937944b.webp";